import React from 'react'
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts'
import { Card } from 'antd'

interface ToolUtilizationData {
  name: string
  utilized: number
  available: number
}

interface ToolUtilizationChartProps {
  data: ToolUtilizationData[]
  height?: number
  title?: string
}

export const ToolUtilizationChart: React.FC<ToolUtilizationChartProps> = ({
  data,
  height = 300,
  title = 'Tool Utilization by Type',
}) => {
  return (
    <Card title={title} bordered style={{ marginBottom: '24px' }}>
      <ResponsiveContainer width="100%" height={height}>
        <BarChart data={data} margin={{ top: 5, right: 30, left: 0, bottom: 5 }}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis label={{ value: 'Units', angle: -90, position: 'insideLeft' }} />
          <Tooltip contentStyle={{ backgroundColor: '#f5f5f5', border: '1px solid #d9d9d9' }} />
          <Legend />
          <Bar
            dataKey="utilized"
            fill="#1890ff"
            name="In Use"
            stackId="utilization"
            radius={[0, 0, 0, 0]}
          />
          <Bar
            dataKey="available"
            fill="#52c41a"
            name="Available"
            stackId="utilization"
            radius={[4, 4, 0, 0]}
          />
        </BarChart>
      </ResponsiveContainer>
    </Card>
  )
}
